import { SHA_APPROVAL_STATES, type ShaApprovalState } from '@wodi/domain';
import { z } from 'zod';

// The SHA approval gate as the lab, procedure and pharmacy screens show it
// (docs/plans/phase1-sha.md §9.3). Null on a visit SHA doesn't pay for.

export { SHA_APPROVAL_STATES };
export type { ShaApprovalState };

/** The shared gate wording (plan §9.3); a decline adds SHA's reason after a colon. */
export const SHA_APPROVAL_LABELS: Record<ShaApprovalState, string> = {
  not_required: 'No SHA approval needed',
  requirement_unknown: 'Pre-authorisation list not loaded',
  needs_request: 'Needs approval from SHA',
  request_failed: 'Couldn’t ask SHA for approval',
  waiting: 'Waiting for SHA approval',
  approved: 'SHA approved',
  declined: 'SHA declined',
  overridden: 'Going ahead without SHA approval',
};

export const shaApprovalSchema = z.object({
  state: z.enum(SHA_APPROVAL_STATES),
  /** SHA's reason, as given, when it declined. */
  reason: z.string().nullable(),
});
export type ShaApprovalView = z.infer<typeof shaApprovalSchema>;

/** The tag text: the label, with SHA's reason after a decline. */
export function shaApprovalText(view: ShaApprovalView): string {
  const label = SHA_APPROVAL_LABELS[view.state];
  return view.state === 'declined' && view.reason !== null ? `${label}: ${view.reason}` : label;
}
